import * as React from 'react';

import { getTermValue } from '../../../../../JsonQuery';
import { Possessor } from '../../../components/advancedFilters/Possessor';
import { ESuburbanOfferFilter } from '../../../types/jsonQuery';
import { useContext } from '../../../utils/useContext';
import { HOMEOWNER } from './constants';

export type THomeowner = typeof HOMEOWNER;

export const PossessorContainer = () => {
  const { jsonQuery, onChange } = useContext();

  const offerFilter = getTermValue('suburban_offer_filter')(jsonQuery) || ESuburbanOfferFilter.Any;
  const isByHomeowner = getTermValue('is_by_homeowner')(jsonQuery);

  const possessor = React.useMemo(() => (isByHomeowner ? HOMEOWNER : offerFilter), [isByHomeowner, offerFilter]);

  const handlePossessorChange = React.useCallback(
    (possessor: ESuburbanOfferFilter | THomeowner) => {
      if (possessor === HOMEOWNER) {
        onChange({ action: 'setIsByHomeowner', arguments: [true] }, { action: 'setPossessor', arguments: [null] });
      } else {
        const value = possessor !== ESuburbanOfferFilter.Any ? possessor : null;

        onChange({ action: 'setPossessor', arguments: [value] }, { action: 'setIsByHomeowner', arguments: [null] });
      }
    },
    [onChange],
  );

  return <Possessor value={possessor} onChange={handlePossessorChange} />;
};
